import React, { useEffect, useState } from "react";
import useSafeAreaListener from "@utils/specific/capacitor/useSafeAreaListener";

const headerPlusSliderHeight = 180 + 96;

export const useDynamicMinHeight = (
	differentSliderHeight = headerPlusSliderHeight
) => {
	const safeAreaPadding = useSafeAreaListener();
	const safePadding = safeAreaPadding.split("px ");
	const paddingY = parseInt(safePadding[0]) + parseInt(safePadding[2]);

	const [minHeight, setMinHeight] = useState(0);

	useEffect(() => {
		const updateMinHeight = () => {
			const viewportHeight = window.innerHeight;
			let carouselHeight;

			if (window.matchMedia("(max-width: 20em)").matches) {
				carouselHeight = 168;
			} else {
				carouselHeight = differentSliderHeight;
			}

			setMinHeight(viewportHeight - carouselHeight - paddingY);
		};

		updateMinHeight();

		window.addEventListener("resize", updateMinHeight);

		return () => {
			window.removeEventListener("resize", updateMinHeight);
		};
	}, [paddingY]);

	return minHeight;
};

export default useDynamicMinHeight;
